import { Component } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { actions } from 'forms/rrf';
import PageTitle from '../common/page-title';
import InlineCKEditor from '../common/editor/inline-editor';
import StaffList from './staff-list';
import { getStaffByOutlet } from '../../actions/staff';
import { getOutlets } from '../../actions/outlet';
import { loadPageContent } from '../../actions/content';
import SearchableSelect from '../common/form/elements/searchable-select';
import MyStaffHeader from '../../assets/img/my_staff_header.jpg';
import EditStaff from './edit-staff';

import './my-staff.css';

class MyStaff extends Component {
  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  constructor(props) {
    super(props);

    this.state = {
      outlet: null,
      modalOpen: false,
    };

    this.pageSlug = 'my-staff';
    this.staff = [];
  }

  openModal = () => {
    this.setState(() => ({
      modalOpen: true,
    }));
  }

  closeModal = () => {
    this.setState(() => ({
      modalOpen: false,
    }));
    this.props.dispatch(actions.reset('deep.staff_member'));
    this.props.dispatch(actions.setFieldsErrors('deep.staff_member', {}));
  }

  UNSAFE_componentWillMount() {
    this.props.dispatch({type: 'CLEAR_EDIT_STAFF_MEMBER'});
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  }

  componentDidMount() {
    this.props.dispatch(getOutlets());
  }

  updateSelectedOutlet = () => {
    if (this.props.stores[0]) {
      this.setState({
        outlet: this.props.stores[0].id
      }, () => {
        this.props.dispatch(getStaffByOutlet(this.state.outlet));
      });
    }
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps.stores !== this.props.stores) {
      const outletOptions = this.props.stores.map(store => (
        {
          value: store.id,
          label: store.attributes.name
        }
      ));

      this.setState({
        outletOptions
      }, () => {
        this.updateSelectedOutlet();
      });
    }
  };

  handleOutletChange = (event) => {
    this.setState({
      outlet: this.state.outletOptions.find(x => x.value === event).value
    }, () => {
      this.props.dispatch(getStaffByOutlet(this.state.outlet));
    });
  };


  render() {
    if (this.props.outletsLoading) {
      return (<h1 key={0}>Loading...</h1>);
    }

    return (
      <div className="my-staff">
        <Container className="user-inner-container">
          <EditStaff show={this.state.modalOpen} onClose={this.closeModal} outlet={this.state.outlet} />
          <Row>
            <Col lg={12} className="my-staff-title">
              <PageTitle>My staff</PageTitle>
            </Col>
          </Row>
          <Row>
            <Col lg={12} className="my-staff-editable-content">
              <InlineCKEditor
                contents={this.props.contents[`${this.pageSlug}_content_text`]}
                identifier={`${this.pageSlug}_content_text`}
                onContentSaved={this.handleContentSaved}
              />
            </Col>
          </Row>
        </Container>
        <div className="my-staff-banner">
          <img src={MyStaffHeader} />
        </div>
        <div className="container user-inner-container">
          <div className="my-staff-filters">
            <SearchableSelect
              label='Outlet'
              model='deep.my_staff.outlet_id'
              options={this.state.outletOptions}
              value={this.state.outlet}
              onChange={e => this.handleOutletChange(e)}
            />
          </div>
          <StaffList
            openModal={this.openModal}
            fetched={this.props.fetched}
            fetching={this.props.fetching}
            staff={this.props.staff}
            outlet={this.state.outlet}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  staff: state.staff.staff,
  fetched: state.staff.fetched,
  fetching: state.staff.fetching,
  contents: state.content.list,
  outletsLoading: state.stores.fetching && !state.stores.fetched,
  stores: state.stores.stores,
  staff_member_relationships: state.staff.staff_member_relationships,
});

export default connect(mapStateToProps)(MyStaff);
